import { log } from "./log.js";
import { sha256 } from "js-sha256";
import { app } from "./app.js";
import useAuth from "./firebase.js";
import useGrpc from "./grpc.js";
import {
  getGradeEnumValue,
  getPathwayName,
  getPathwayId,
  getUserTypeId,
  getUserTypeName,
  getGradeFromEnumValue,
  getPathwayIdByValue,
} from "./utils.js";
import { Pathways } from "./grpc/pathway_pb";
import { set, get } from "./state.js";
import { hideSpinner, showSpinner } from "./fullscreenSpinner.js";

const auth = useAuth();
const grpc = useGrpc();

const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

let signupInfo = {};
let signupError = "";

function validInput() {
  let success = true;

  signupInfo.score = 0;

  const userType = document.querySelector(".itp-signup-user-type select");

  if (userType != null && userType.value !== "") {
    signupInfo.accountType = userType.value;
  } else {
    alertify.error("Must select account type");
    success = false;
    return false;
  }

  const fnameArr = document.querySelectorAll(
    ".itp-signup-name .name_first input"
  );

  let fname = null;
  for (let elem of fnameArr) {
    if (elem.offsetParent != null) {
      fname = elem;
    }
  }

  if (fname != null && fname.value !== "") {
    signupInfo.fname = fname.value;
  } else {
    alertify.error("Enter your first name");
    success = false;
  }

  const lnameArr = document.querySelectorAll(
    ".itp-signup-name .name_last input"
  );

  let lname = null;
  for (let elem of lnameArr) {
    if (elem.offsetParent != null) {
      lname = elem;
    }
  }

  if (lname != null && lname.value !== "") {
    signupInfo.lname = lname.value;
  } else {
    alertify.error("Enter your last name");
    success = false;
  }

  const emailArr = document.querySelectorAll(".itp-signup-email input");

  let email = null;
  for (let elem of emailArr) {
    if (elem.offsetParent != null) {
      email = elem;
    }
  }

  if (!emailRegex.test(email.value.toLowerCase())) {
    alertify.error("Invalid email. Please check your email closely.");
    success = false;
  }

  if (email != null && email.value !== "") {
    signupInfo.email = email.value.toLowerCase();
  } else {
    alertify.error("Enter your email address");
    success = false;
  }

  // if (userType.value !== "Citizen") {
  // const schoolArr = document.querySelectorAll(".itp-signup-school select");

  // let school = null;
  // for (let elem of schoolArr) {
  //   if (elem.offsetParent != null) {
  //     school = elem;
  //   }
  // }

  // const schoolOtherArr = document.querySelectorAll(
  //   ".itp-signup-school-other input"
  // );

  // let schoolOther = null;
  // for (let elem of schoolOtherArr) {
  //   if (elem.offsetParent != null) {
  //     schoolOther = elem;
  //   }
  // }

  // if (school != null && school.value !== "") {
  //   if (
  //     school.value === "Other" &&
  //     (schoolOther == null || schoolOther.value === "")
  //   ) {
  //     success = false;
  //     alertify.error("Enter your school name");
  //   }

  //   signupInfo.school =
  //     school.value === "Other" ? schoolOther.value : school.value;
  // } else {
  //   alertify.error("Enter your school name");
  //   success = false;
  // }
  const countyArr = document.querySelectorAll(".itp-signup-county select");
  const county = countyArr[0].value;

  if (county != null && county !== "") {
    signupInfo.county = county;
  } else {
    alertify.error("Select your county");
    success = false;
  }

  const schoolArr = document.querySelectorAll(
    `.itp-signup-school-${county.toLowerCase()} select`
  );
  const school = schoolArr[0].value;

  if (school != null && school !== "") {
    signupInfo.school = school;
  } else {
    alertify.error("Select your school name");
    success = false;
  }

  console.log(signupInfo.school, signupInfo.county);
  // }

  let chosenGrade = 0;

  if (userType.value !== "Citizen") {
    const gradeArr = document.querySelectorAll(
      '.itp-signup-grade input[type="radio"]:checked'
    );

    let grade = null;

    for (let elem of gradeArr) {
      if (elem.offsetParent != null) {
        grade = elem;
      }
    }

    if (grade != null && grade.value !== "") {
      signupInfo.grade = parseInt(grade.value, 10);
      if (isNaN(signupInfo.grade)) {
        signupInfo.grade = 0;
        alertify.error("Enter your grade");
        success = false;
      }
      chosenGrade = signupInfo.grade;
    } else {
      alertify.error("Enter your grade");
      success = false;
    }
  }

  console.log(userType.value + " " + chosenGrade);

  if (userType.value === "Student" && chosenGrade === 10) {
    const uscienceQ = document.querySelector(
      '.itp-uscience-question input[type="radio"]:checked'
    );
    const usciencePicks = jQuery(".itp-uscience-picks select").chosen().val();

    if (
      uscienceQ != null &&
      typeof usciencePicks !== "undefined" &&
      usciencePicks != null &&
      uscienceQ.value === "Yes"
    ) {
      signupInfo.interestedPathways = usciencePicks;
      console.log(usciencePicks);
    } else {
      alertify.error(
        "You must complete an interest or aptitude assessment (i.e. YouScience, Major Clarity, etc.)"
      );
      success = false;
      console.log(
        "You must complete an interest or aptitude assessment (i.e. YouScience, Major Clarity, etc.)"
      );
    }
  }

  const usernameArr = document.querySelectorAll(".itp-signup-username input");

  let username = null;
  for (let elem of usernameArr) {
    if (elem.offsetParent != null) {
      username = elem;
    }
  }

  if (username != null && username.value !== "") {
    signupInfo.username = username.value;
  } else {
    alertify.error("Must provide a nickname.");
    success = false;
  }

  const passwordArr = document.querySelectorAll(".itp-signup-password input");

  let password = null;
  for (let elem of passwordArr) {
    if (elem.offsetParent != null) {
      password = elem;
    }
  }

  if (password != null && password.value !== "") {
    if (password.value.length < 6) {
      alertify.error("Password must be at least 6 characters.");
      success = false;
    }
  }

  const password2Arr = document.querySelectorAll(".itp-signup-password2 input");

  let password2 = null;
  for (let elem of password2Arr) {
    if (elem.offsetParent != null) {
      password2 = elem;
    }
  }

  // if sent from login or another page when
  // getUserData is empty
  const needMoreInfo = get("need-profile-info") ?? false;

  if (
    needMoreInfo ||
    (password != null &&
      password != null &&
      password?.value !== "" &&
      password2?.value !== "" &&
      password?.value === password2?.value)
  ) {
    signupInfo.password = password?.value ?? "";
  } else {
    alertify.error("Both password fields must match and must not be empty");
    success = false;
  }

  // if (userType.value === "Citizen") {
  //   const county = document.querySelector(".itp-signup-county select");
  //   const countyOther = document.querySelector(
  //     ".itp-signup-county-other input"
  //   );

  //   if (county != null && county.value !== "") {
  //     if (
  //       county.value === "Other" &&
  //       (countyOther == null || countyOther.value === "")
  //     ) {
  //       success = false;
  //       alertify.error("Enter your county name");
  //     }

  //     signupInfo.county =
  //       county.value === "Other" ? countyOther.value : county.value;
  //   } else {
  //     alertify.error("Enter your county name");
  //     success = false;
  //   }
  // }

  if (!success) {
    alertify.error("Please enter all required fields and try again.");
  }

  return success;
}

// returns true if all required fields were successfully stored
function storeAccountData(userData) {
  let success = true;
  console.log(userData.grade);
  console.log(getGradeEnumValue(userData.grade));

  if (!set("id", auth.getCurrentUser().uid ?? "")) success = false;
  if (!set("email", userData.email ?? "")) success = false;
  if (!set("accountType", getUserTypeId(userData.accountType) ?? 0))
    success = false;
  if (!set("username", userData.username ?? "")) success = false;
  if (!set("fname", userData.fname ?? "")) success = false;
  if (!set("lname", userData.lname ?? "")) success = false;
  if (!set("grade", getGradeEnumValue(userData.grade + "") ?? ""))
    success = false;
  if (!set("score", 0)) success = false;
  if (!set("school", userData.school ?? "")) success = false;
  if (!set("county", userData.county ?? "")) success = false;

  if (
    !set(
      "interestedPathways",
      JSON.stringify(
        userData.interestedPathways?.map((p) => Pathways[getPathwayId(p)]) ?? []
      )
    )
  )
    success = false;
  if (!set("timestamp", Math.floor(Date.now() / 1000))) success = false;

  return success;
}

function doSignup(evt) {
  log("Attempting to sign up");
  showSpinner();

  signupInfo = {};
  signupError = "";

  if (validInput()) {
    auth
      .createUser({ email: signupInfo.email, password: signupInfo.password })
      .then(async (user) => {
        // console.log(
        //   "User created successfully",
        //   await auth.getCurrentUser()?.getIdToken() ?? ""
        // );
        let isUpdatingExistingAccount = false;

        if (!user) {
          hideSpinner();
          throw new Error("Error: USER NOT CREATED");
        }

        if (user.hasOwnProperty("error")) {
          if (user.error.includes("email-already-in-use")) {
            isUpdatingExistingAccount = true;
          }
          throw new Error("ACCOUNT ALREADY EXISTS");
        }

        let success = storeAccountData(signupInfo);
        if (!success) {
          hideSpinner();
          console.log("Error storing account data");
          alertify.error("Error storing account data. Try again.");
          return;
        }
        console.log("Account data stored successfully");

        success = await grpc.updateUserData();
        if (!success) {
          hideSpinner();
          console.log("Error updating user data");
          alertify.error("Error updating user account. Try again.");
          return;
        }
        console.log("User data updated successfully");

        // handles user updating data
        if (isUpdatingExistingAccount) {
          hideSpinner();
          set("need-profile-info", false);
          alertify.success("Successfully updated account data.");
          window.location.replace(app.home);
          return;
        }

        hideSpinner();
        alertify.success("Signup successful!");
        alertify.success("Redirecting to the app now...");
        window.location.replace(app.home);
      })
      .catch((err) => {
        signupError = err;
        setSignupError();
        console.log(err);
        hideSpinner();
        alertify.error('Error creating user. Try again. Error: "' + err + '"');
      });
  } else {
    hideSpinner();
  }
}

export function setSignupError() {
  const errorEls = document.querySelectorAll(".itp-signup-error");

  for (let elem of errorEls) {
    elem.innerHTML = `<p>${signupError}</p>`;
  }

  if (signupError !== "") {
    for (let elem of errorEls) {
      elem.classList.add("itp-signup-error-show");
    }
  } else {
    for (let elem of errorEls) {
      elem.classList.remove("itp-signup-error-show");
    }
  }
}

export function signup() {
  const signup = document.querySelector("#itp-signup-btn");

  // in case user is updating their account
  auth.ready().then(() => {
    const user = auth.getCurrentUser();
    if (user) {
      signupInfo.email = get("email") || user.email || "";
      signupInfo.username = get("username") || "";
      signupInfo.fname = get("fname") || "";
      signupInfo.lname = get("lname") || "";
      signupInfo.grade = get("grade") || "";
      signupInfo.school = get("school") || "";
      signupInfo.county = get("county") || "";
      signupInfo.accountType = get("accountType") || "";
      signupInfo.interestedPathways =
        JSON.parse(get("interestedPathways"))?.map((p) => getPathwayName(p)) ||
        [];

      const userTypeEl = document.querySelector(".itp-signup-user-type select");
      userTypeEl.value = getUserTypeName(signupInfo.accountType);
      jQuery(userTypeEl).trigger("change");
      // jQuery(userTypeEl).val(signupInfo.accountType).change();

      const fnameEl = document.querySelector(".name_first input");
      fnameEl.value = signupInfo.fname;

      const lnameEl = document.querySelector(".name_last input");
      lnameEl.value = signupInfo.lname;

      const emailEl = document.querySelector(".itp-signup-email input");
      emailEl.value = signupInfo.email;

      const usernameEl = document.querySelector(".itp-signup-username input");
      usernameEl.value = signupInfo.username;

      const gradeArr = document.querySelectorAll(
        '.itp-signup-grade input[type="radio"]'
      );
      const grade = getGradeFromEnumValue(signupInfo.grade);
      gradeArr.forEach((g) => {
        if (g.value == grade) {
          g.checked = true;
        }
      });

      const schoolEl = document.querySelector(".itp-signup-school select");
      schoolEl.value = signupInfo.school;

      const countyEl = document.querySelector(".itp-signup-county select");
      countyEl.value = signupInfo.county;

      // let fullPathways = signupInfo.interestedPathways.map((p) =>
      //   getPathwayName(getPathwayIdByValue(p))
      // );
      // console.log(fullPathways);

      // if (fullPathways.length > 0) {
      //   jQuery(".itp-uscience-picks select").chosen().val(fullPathways);
      //   jQuery(".itp-uscience-picks select").trigger("chosen:updated");
      // }

      // jQuery(".itp-signup-password input").hide();
      // jQuery(".itp-signup-password2 input").hide();
    }
  });

  const needMoreInfo = get("need-profile-info") ?? false;

  if (needMoreInfo) {
    // need to wait for page to fully load?
    document.addEventListener("DOMContentLoaded", () => {
      // hide password fields
      jQuery(".itp-signup-password").hide();
      jQuery(".itp-signup-password2").hide();
      jQuery(".gform_title").text("Update Account Information");

      // add banner to top of form
      const banner = document.createElement("div");
      banner.classList.add("itp-signup-banner");
      banner.innerHTML = `
      <div class="itp-signup-banner-content">
        <h3>Update your account</h3>
        <p>
          You need to update your account information before you can access the app.
        </p>
      </div>
    `;
      document.querySelector(".itp-signup-form_wrapper").prepend(banner);

      const signupBtn = jQuery("#itp-signup-btn img").get(0);
      signupBtn.src =
        "https://itpcareerexpo.com/wp-content/uploads/2020/06/continue-button.gif";
    });
  }

  if (signup != null) {
    signup.onclick = doSignup;
  }

  const passwordSection = document.querySelector(".itp-signup-password");
  // add a hint to the password section that state a min of 6 characters
  const passwordHint = document.createElement("div");
  passwordHint.classList.add("itp-signup-password-hint");
  passwordHint.innerHTML = `
    <p>
      Password must be at least 6 characters.
    </p>
  `;
  passwordSection.appendChild(passwordHint);
}

export default {};
